export const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const vinPattern = /^(?=.*[0-9])(?=.*[A-z])[0-9A-z-]{17}$/;

export const datePattern = /^\d{4}-\d{2}-\d{2}$/;

export const dateRangePattern = /^\d{4}-\d{2}-\d{2} - \d{4}-\d{2}-\d{2}$/;

export const nipPattern = /^\d{10}$/;

export const drivingLicenseNumberPattern = /^[A-Z]{1,2}[0-9]{6,7}$/;
